import Styles from './EnableAutoReload.module.scss'

import ToggleButton from 'common/ToggleButton/ToggleButton'
import { Check02 } from 'blaze-ui/icons/16'
import { Heading } from 'blaze-ui/Heading/Heading'
import { Text } from 'blaze-ui/Text/Text'

export const EnableAutoReload = ({
  shouldAutoReloadCredits,
  toggleAutoReloadCredits,
  name,
}: {
  shouldAutoReloadCredits: boolean
  toggleAutoReloadCredits: () => void
  name: string
}) => {
  return (
    <div className={Styles.autoReloadCreditsContainer}>
      <div className={Styles.textAndToggle}>
        <Heading level={5}>Enable auto-reload</Heading>
        <ToggleButton checked={shouldAutoReloadCredits} name={name} handleChange={toggleAutoReloadCredits} />
      </div>
      <div className={Styles.checklist}>
        <div className={Styles.checklistItem}>
          <Check02 color="var(--dark-40)" />
          <Text variant="secondary" color="var(--dark-60)">
            Keep content generating without interruption
          </Text>
        </div>
        <div className={Styles.checklistItem}>
          <Check02 color="var(--dark-40)" />
          <Text variant="secondary" color="var(--dark-60)">
            Automatically add 100 credits when running low, up to $50/month
          </Text>
        </div>
        <div className={Styles.checklistItem}>
          <Check02 color="var(--dark-40)" />
          <Text variant="secondary" color="var(--dark-60)">
            Change anytime
          </Text>
        </div>
      </div>
    </div>
  )
}
